import { useMemo } from 'react';
import { usePlaces } from './usePlaces';
import { searchCatalog } from '@shared/search';

export function useSearch(query: string) {
  const { places, loading } = usePlaces();
  const results = useMemo(() => searchCatalog(query, places), [query, places]);
  return { results, loading };
}
